// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { wishListSharingStatusStyles } from "@ces/Overrides/Components/WishListSharingStatus";
import { color } from "@ces/XDL/Utilities";
import Users from "@insite/mobius/Icons/Users";
import { css } from "styled-components";

wishListSharingStatusStyles.privateTooltip = {
    mergeCss: true,
    iconProps: {
        size: 13,
        color: "info",
    },
    cssOverrides: {
        tooltipWrapper: css`
            display: flex;
            align-items: center;
            padding-bottom: 1px;
            position: relative;
            [data-tippy-root] {
                overflow-x: visible;
                min-width: 250px;
            }
        `,

        tooltipClickable: css`
            &&& {
                height: 13px;
                margin-left: 5px;
            }
        `,
    },
};

wishListSharingStatusStyles.statusText = {
    css: css`
        &&&& {
            font-size: 12px;
            display: flex;
            align-items: center;
            > span {
                display: flex;
                align-items: center;
            }
        }
    `,
};

wishListSharingStatusStyles.sharedIcon = {
    src: Users,
    size: 15,
    color: "common.ui8",
    css: css`
        margin-right: 5px;

        &:hover {
            svg {
                color: ${color("text.link")};
            }
        }
    `,
};

wishListSharingStatusStyles.autogeneratedText = {
    css: css`
        margin-right: 5px;
    `,
};
